module.exports = __webpack_public_path__ + "img/empty.108ad894.png";